import { css } from 'styled-components';
import media from 'styles/media';

export const sliderContainerStyles = css`
  position: relative;
  z-index: 1;

  overflow: hidden;
  min-height: 200px;
`;

export const rootStyles = css`
  position: relative;
  width: 100%;

  &.isPrevArrowShown {
    left: 25px;
  }
`;

export const wrapperStyles = css`
  height: 100%;
  display: flex;
`;

export const itemContainerStyles = css`
  position: relative;
  user-select: none;
  flex-shrink: 0;
  width: auto;
  object-fit: cover;
  z-index: 1;
  padding-right: 20px;

  ${media.small`
  width: 100%;
  max-width:420px;
  `}

  &:last-child {
    padding-right: 0;
  }
`;

export const infoStyles = css`
  right: 0;
  width: auto;
  height: auto;
  z-index: 10000;
`;

export const nextButtonStyles = css`
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 25px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  z-index: 10000;
  opacity: 0;

  &.hide {
    display: none;
  }

  &:disabled {
    pointer-events: none;
    & > svg {
      opacity: 0.2;
    }
  }
`;

export const prevButtonStyles = css`
  ${nextButtonStyles}
  top: 0;
  left: 0;
  right: unset;
`;
